// extracted by mini-css-extract-plugin
export default {"wrapper":"slopes-module--wrapper--df429"};